import React from "react";
// import preloader from "../Media/Images/icon/preloader.svg";

const Preloader = () => {
  return (
    <div id="preloader">
      <div id="loading-center">
        <div id="loading-center-absolute">
          <img
            // src={preloader}
            // src="img/icon/preloader.svg"
            alt=""
          />
        </div>
      </div>
    </div>
  );
};
export default Preloader;